<template>
    <div class="navigation-bar --align">
        <v-progress-linear indeterminate absolute top color="#1F8F58" v-if="masterLoader"/>
        <div class="left-portion flex space-between"> 
            <img v-if="type=='crm'" src="@/assets/crmlogo.svg" alt="">
             <img v-if="type!='crm'" src="@/assets/logo.svg" alt="">
            <v-text-field 
                class="search-input"
                placeholder="Search"
                prepend-inner-icon="mdi-magnify"
                outlined
                hide-details
                style="visibility : hidden;"
            />
        </div>
        
        <div class="right-portion flex">
            <v-badge color="#1F8F58" dot class="mr-8 mt-1" v-if="false">
                <v-icon color="#919191" style="margin : -5px -8px 0 0" size="30" class="pointer">mdi-bell-outline</v-icon>
            </v-badge>
            <div class="dropdown">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-avatar color="red" size="35">
                            <img :src="user.avatar ? user.avatar : dummyAvatar" alt="" referrerpolicy="no-referrer">
                        </v-avatar>
                        <button v-bind="attrs" v-on="on" class="pl-1"> 
                            {{ user.name }} 
                            <v-icon class="mb-1"> mdi-chevron-down </v-icon>
                        </button>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-avatar>
                                <img :src="user.avatar ? user.avatar : dummyAvatar">
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title> {{ user.name }} </v-list-item-title>
                                <v-list-item-subtitle> {{ user.brand.name }} </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>
                        <v-list-item
                            :style="{ 'color' : item.title === 'Logout' ? '#B14B4B' : '#474747' }"
                            class="--appy-font"
                            link
                            v-for="(item, index) in items"
                            :key="index"
                            @click="checkActionAndAct(item.action)"
                        >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'navigationBar',

    data() {
        return {
            items: [
                {
                    title : 'Profile Settings',
                    action : 'profileSettings'
                },
                // {
                //     title : 'Need Help?'
                // },
                {
                    title : 'Logout',
                    action : 'logout'
                },
            ],

            dummyAvatar : require("../../../assets/DummyAvatar.png")
        }
    },

    props:{
        type:{
            default:'Business'
        }
    },

    computed : {
        user() {
            return this.$store.getters['mainStore/GET_USER_DETAILS'];
        }
    },

    methods : {
        checkActionAndAct(action) {
            if(action === 'profileSettings')
                this.$router.push({ name : 'profileSettings' })
            else if(action === 'logout')
                this.$store.dispatch('mainStore/logoutUser');
        }
    }
}
</script>

<style lang="scss" scoped>

.navigation-bar {
    background-color : white;
    box-shadow: 1px 1px 1px rgba(15, 51, 32, 0.07);
    position: sticky;
    top: 0;
    z-index: 5;
}

.left-portion img {
    width: 140px;
    height: 48px;
    margin-right: 50px;
}

.right-portion button {
    color: #474747;
    font-family: "Roboto";
}

@media all and (min-width : 1000px) {
    .navigation-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
        margin-bottom: 15px;
    }

    .left-portion {
        width: 50%;
    }

    .right-portion {
        width: 40%;
        justify-content: flex-end;
    }

    .right-portion button {
        font-size: 18px;
    }
}

</style>

<style lang="scss">
.search-input fieldset {
    color: white !important;
}

</style>